import React from 'react';
import { Alert } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { hideAlert } from '../../redux/reducers/alertSlice';

const CustomAlert = () => {
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alert);

  React.useEffect(() => {
    if (alert.show) {
      const timer = setTimeout(() => {
        dispatch(hideAlert());
      }, alert.timeout??3000); 
      
      return () => clearTimeout(timer); 
    }
  }, [alert, dispatch]);

  return (
    alert.show && (
      <div className='position-fixed text-center' style={{ right: '20px', marginTop:'5.35rem', zIndex: '9999' }}>
      {/*  <div className='position-fixed top-0 w-50 end-5 mt-3 me-20' style={{ zIndex: 9999 }}> */}
        <Alert
          variant={alert.variant}
          style={
            alert.variant === 'success'
              ? {
                  backgroundColor: '#3a7846',
                  color: 'white',
                  paddingRight: '5rem',
                  paddingLeft: '5rem',
                }
              : {
                paddingRight: '5rem',
                paddingLeft: '5rem',
                }
          }
        >
          {alert.message}
        </Alert>
      </div>
    )
  );
};

export default CustomAlert;